import AOS from 'aos';

function accordionMobileInit() {
    // Base hooks for the accordion
    const hooks = {
        group: '[data-accordion-mobile]',
        content: '[data-accordion-mobile-content]',
        title: '[data-accordion-mobile-title]',
        track: '[data-accordion-mobile-track]',
    };

    // All used classes are declared here
    const classes = {
        active: 'is-active',
        trackClicked: 'rotate-180',
    };

    const maxMobileScreenWidth = 1024;

    // Function to check if it's mobile view
    function isMobileView() {
        return window.innerWidth < maxMobileScreenWidth;
    }

    // Initialize accordions based on the viewport
    function initAccordions() {
        // Slide up or down based on the viewport width
        if (isMobileView()) {
            $(hooks.content).slideUp();
            $(hooks.track).addClass(classes.trackClicked);
        } else {
            $(hooks.content).slideDown();
            $(hooks.track).removeClass(classes.trackClicked);
        }

        // Set tabindex="0" for each title for accessibility
        $(hooks.title).each(function () {
            $(this).attr('tabindex', '0');
        });
    }

    // Toggle the accordion's state
    function toggleAccordion(e) {
        if (isMobileView()) {
            const group = $(this).closest(hooks.group);
            const content = group.find(hooks.content);
            const track = group.find(hooks.track);

            group.toggleClass(classes.active);
            track.toggleClass(classes.trackClicked);

            // eslint-disable-next-line jquery/no-slide
            content.slideToggle(300);

            // Refresh Animation on Scroll (AOS) events
            setTimeout(function () {
                AOS.refresh();
            }, 300);
        }
    }

    // Event binding for accordion interaction
    function bindAccordionEvents() {
        $(hooks.title)
            .off('click')
            .click(toggleAccordion)
            .off('keydown')
            .keydown(function (e) {
                if (e.keyCode === 13) {
                    // Enter key
                    toggleAccordion.call(this, e);
                }
            });
    }

    // Adjust tabindex only for containers with the custom attribute
    function adjustAccordionTabindex() {
        $(hooks.title).each(function () {
            const $title = $(this);
            const $container = $title.closest(
                '[data-disable-tabindex-on-desktop="true"]',
            );

            // Only modify if the title is within a container with data-disable-tabindex-on-desktop="true"
            if ($container.length > 0) {
                // Check if this is any block in the homepage sidebar that gets hidden
                const isInHomepageSidebar =
                    document.body.classList.contains('home') &&
                    $container.closest('.o-posts-overview-2__column--2')
                        .length > 0;

                if (isInHomepageSidebar) {
                    // For any block in homepage sidebar, always set tabindex to -1
                    $title.attr('tabindex', '-1');
                } else {
                    // For blocks on other pages, maintain the existing mobile/desktop behavior
                    if (isMobileView()) {
                        $title.attr('tabindex', '0');
                    } else {
                        $title.attr('tabindex', '-1');
                    }
                }
            }
        });
    }

    // Apply adjustAccordionTabindex on window load to catch any late assignments
    $(window).on('load', adjustAccordionTabindex);

    // Resize event to adjust accordion behavior based on viewport size
    $(window).resize(function () {
        initAccordions(); // Reinitialize accordions based on the new viewport size
        adjustAccordionTabindex();
    });

    // Initial setup
    bindAccordionEvents();
    initAccordions();
    adjustAccordionTabindex();

    // Debounced resize handler to avoid flickering
    let resizeTimeout;
    $(window).resize(function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            adjustAccordionTabindex();
        }, 150);
    });
}

export default accordionMobileInit;
